/**
 * @Author: abbeymart | Abi Akindele | @Created: 2020-09-13
 * @Company: Copyright 2020 Abi Akindele  | mConnect.biz
 * @License: All Rights Reserved | LICENSE.md
 * @Description: mcweb: folder routes map
 */

import type { RouteRecordRaw } from 'vue-router';

export const folderRoutes: Array<RouteRecordRaw> = [
  {
    path: '/folder',
    name: 'folder',
    redirect: '/folder/list',
    component: () => import('pages/central/folder/McFolder.vue'),
    meta: {
      title: 'Folders',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'folderList',
        component: () => import('pages/central/folder/FolderList.vue'),
        meta: {
          title: 'Folders List',
          requiresAuth: true,
          // /:categoryId?/:appId?/:path?
        },
      },
      {
        path: 'detail',
        name: 'folderDetail',
        component: () => import('pages/central/folder/FolderDetail.vue'),
        meta: {
          title: 'Folder Details',
          requiresAuth: true,
        },
        // /:itemId?/:categoryId?/:appId?/:path?
      },
      {
        path: 'new',
        name: 'folderNew',
        component: () => import('pages/central/folder/FolderNew.vue'),
        meta: {
          title: 'New Folder',
          requiresAuth: true,
        },
      },
    ],
  },
];
